const SNAKE = {
    name: 'Snake',
    description: "Un jeu snake basique dans lequel j'ai testé la librairie Phaser.",
    technologies: ['HTML', 'CSS', 'JavaScript', 'Phaser3'],
    firstReleaseDate: '24/03/2018'
};

export default SNAKE;
